// How audiences are selected on a query stage — shared with the
// move-audiences-to-pdp page, which selects audiences the same way.
export const QUERY_MODES = {
  FILTERS: 'filters',
  IDS: 'ids',
}

export const MODE_OPTIONS = [
  { value: QUERY_MODES.FILTERS, label: 'Filters' },
  { value: QUERY_MODES.IDS, label: 'ID list' },
]

// split a pasted list on whitespace, commas and semicolons, de-duplicated
export const parseIds = (text) => [...new Set(text.split(/[\s,;]+/).filter(Boolean))]
